// extracted by mini-css-extract-plugin
export default {"page":"admin_page__QmMD+","form":"admin_form__TLvBM","download":"admin_download__VTxTA"};